"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const DatahubService_1 = __importDefault(require("../DatahubService"));
const helper_1 = require("../helper");
class DatahubLegacyRedirectService {
    static closeAlertEvent() {
        DatahubLegacyRedirectService.sendEvent(constants_1.EVENTS_LABELS.LEGACY_REDIRECT_ALERT.CLOSE_BUTTON_CLICK);
    }
}
DatahubLegacyRedirectService.showMoreInfoEvent = () => {
    DatahubLegacyRedirectService.sendEvent(constants_1.EVENTS_LABELS.LEGACY_REDIRECT_ALERT.KNOW_MORE_BUTTON_CLICK);
};
DatahubLegacyRedirectService.closeMoreInfoEvent = () => {
    DatahubLegacyRedirectService.sendEvent(constants_1.EVENTS_LABELS.LEGACY_REDIRECT_ALERT.CLOSE_MORE_INFO_BUTTON_CLICK);
};
DatahubLegacyRedirectService.knowMoreInfoEvent = () => {
    DatahubLegacyRedirectService.sendEvent(constants_1.EVENTS_LABELS.LEGACY_REDIRECT_ALERT.KNOW_MORE_INFO_BUTTON_CLICK);
};
DatahubLegacyRedirectService.frequentlyAskedQuestionEvent = () => {
    DatahubLegacyRedirectService.sendEvent(constants_1.EVENTS_LABELS.LEGACY_REDIRECT_ALERT.FREQUENTLY_ASKED_QUESTIONS_CLICK);
};
DatahubLegacyRedirectService.sendEvent = (label) => {
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            action: constants_1.EVENTS_INTERACTIONS.CLICK,
            category: constants_1.EVENTS_CATEGORY.LEGACY_REDIRECT_ALERT,
            label
        })
    });
};
exports.default = DatahubLegacyRedirectService;
